import { ROUTE } from '@/router/routes';
import { SidebarLinkItem } from '@/types/sidebar';

function getLinksPaths(links: SidebarLinkItem[]): ROUTE[] {
    return links.map((link) => link.path);
}

export { getLinksPaths };
